import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./session.css";
import styles from "./Seesion.module.css";
import axios from "axios";
import auth, { getCurrentUser } from "../../../services/authService";
// import ReactPlayer from "react-player";
import moment from "moment";
import Countdown from "react-countdown";
import "./session.css";
import SideMenu from "../sideMenu/sideMenu";
import Agenda from "../../generalEvent/agenda/agenda";
import LoggedNavBar from "../navBar/loggedNav";
import ReactPlayer from "react-player";

function Session() {
  let history = useNavigate();
  const loggedInDate = new Date();
  let videoRef = React.createRef();

  const [isBeforeSession, setIsBeforeSession] = useState(false);
  const [isAfterSession, setIsAfterSession] = useState(false);
  const [user, setUser] = useState({});

  const [videoSource, setVideoSrc] = useState();

  const [slidoShow, setSlidoShow] = useState(true);
  const [agenda, setAgenda] = useState();
  const [loading, setloading] = useState(true);
  const [dates, setDates] = useState([]);
  const [DateAgenda, setDateAgenda] = useState([]);
  const [selectedDate, setselectedDate] = useState("");
  const getAgenda = () => {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}newagenda/getall`)
      .then((r) => {
        setDates(r.data);

        console.log(r.data);
      });
  };
  const getdateAgenda = (date) => {
    console.log(date);
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}newagenda/geteventsbydate`, {
        date: date,
      })
      .then((r) => {
        setDateAgenda(r.data);
        if (r.data.length > 0) {
          let date = new Date(r.data[0].startDate).toLocaleString("default", {
            day: "2-digit",
            month: "short",
          });
          setselectedDate(date);
        }

        console.log(r.data);
      });
  };
  const createFrame = () => {
    return loading
      ? null
      : {
          __html: `
        <iframe
        width:"100%"
        height:"100%"
        class='live-video'
        src=${agenda[0].sessionLink}
        allowFullScreen
        ></iframe>`,
        };
  };
  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      axios
        .get(
          `${process.env.REACT_APP_SERVER_URL}session/getSessionByRegion/${
            getCurrentUser().region
          }`
        )
        .then((res) => {
          if (typeof res.data !== "string") {
            console.log(res.data);
            setAgenda(res.data, () => {});
          }

          // isAfterSession(true);
        });
      isFirstRun.current = false;
      checkLoggedTime(loggedInDate);
      return;
    } else {
      checkLoggedTime(loggedInDate);
      return;
    }

    console.log("Effect was run");
  });
  useEffect(() => {
    getAgenda();
  }, []);
  useEffect(() => {
    createFrame();
  }, [isBeforeSession]);

  const handleSlidoShow = () => {
    getdateAgenda(dates[0].date);
    setSlidoShow(!slidoShow);
  };

  const checkLoggedTime = (loggedInDate) => {
    if (agenda != undefined) {
      if (loggedInDate.getTime() < new Date(agenda[0].startDate).getTime()) {
        setIsBeforeSession(true);
      } else {
        setIsBeforeSession(false);
        setIsAfterSession(false);
        setloading(false);
      }
    } else {
      setIsAfterSession(true);
    }
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      setIsBeforeSession(false);
      return null;
    }
    return (
      <div className='col-12 d-flex flex-row  justify-content-center align-items-center DeadlineBoxesContainer'>
        <div className='  d-flex flex-column justify-content-center align-items-center  sectionDeadlineDateBox'>
          <div className=' countdown-number-title'>{days}</div>
          <span className='countdown-number-sub'>Day</span>
        </div>
        <div className='  d-flex flex-column  timer-column'>
          <div class='timer-circle'></div>
          <div class='timer-circle'></div>
        </div>
        <div className='  d-flex flex-column justify-content-center align-items-center sectionDeadlineDateBox'>
          <div className=' countdown-number-title'>{hours}</div>
          <span className='countdown-number-sub'>Hours</span>
        </div>
        <div className='  d-flex flex-column  timer-column'>
          <div class='timer-circle'></div>
          <div class='timer-circle'></div>
        </div>
        <div className='  d-flex flex-column justify-content-center align-items-center sectionDeadlineDateBox'>
          <div className=' countdown-number-title'>{minutes}</div>
          <span className='countdown-number-sub'>Minutes</span>
        </div>
        <div className='  d-flex flex-column  timer-column'>
          <div class='timer-circle'></div>
          <div class='timer-circle'></div>
        </div>
        <div className='  offset-r-2 d-flex flex-column justify-content-center align-items-center sectionDeadlineDateBox '>
          <div className=' countdown-number-title'>{seconds}</div>
          <span className='countdown-number-sub'>Seconds</span>
        </div>
      </div>
    );
  };
  if (isBeforeSession)
    return (
      <>
        <div className='coaches-pageContainer '>
          <LoggedNavBar to='hall' />

          <div
            className='d-flex justify-content-center align-items-center flex-column '
            style={{ minHeight: "88vh" }}
          >
            <Countdown
              date={new Date(agenda[0].startDate)}
              renderer={renderer}
              onComplete={() => {
                setIsBeforeSession(false);
                setloading(false);
              }}
            />
            <h3 className=' text-white'>
              Your live sessions haven't started yet, they will start at{" "}
              {`${moment(agenda[0].startDate).format(
                "ddd MMMM Do, YYYY HH:mm:ss"
              )}`}
            </h3>
            {/* <a
              src='/assets/glb/newmodel/ff1-01.png'
              className='btn-start-finish'
              onClick={() => {
                history("/hall");
              }}
            >
              Back to hall
            </a> */}
          </div>
        </div>
      </>
    );
  if (isAfterSession)
    return (
      <>
        <div className='coaches-pageContainer '>
          <LoggedNavBar to='hall' />
          <div
            className='d-flex justify-content-center align-items-center flex-column'
            style={{ minHeight: "88vh" }}
          >
            <h3 className='text-white'>Your live session has been finished</h3>
            {/* <a
              src='/assets/glb/newmodel/ff1-01.png'
              className='btn-start-finish'
              onClick={() => {
                history("/hall");
              }}
            >
              Back to hall
            </a> */}
          </div>
        </div>
      </>
    );
  return (
    <div className='session-body'>
      <div className={styles["videocreenheader"]}>
        {/* <div
          className={styles["back-div"]}
          onClick={() => {
            history("/hall");
          }}
        >
          <img src='/assets/chevron-double-left.svg'></img>
          <span className={styles["back-txt"]}>Back</span>
        </div> */}
        <div className={styles["logos-container"]}>
          <img
            src='/assets/_vois_white.png'
            className={styles["vois-logo"]}
          ></img>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='668'
            height='90'
            viewBox='0 0 668 90'
            fill='none'
            className={styles["hack"]}
          >
            <path
              d='M173.926 25.7187C175.329 23.8162 177.164 22.2741 179.28 21.2193C181.395 20.1645 183.731 19.627 186.095 19.6511C187.954 19.615 189.802 19.9486 191.532 20.6325C192.987 21.222 194.353 22.0117 195.589 22.9788C196.629 23.7991 197.551 24.7575 198.331 25.8275C198.901 26.6194 199.431 27.4396 199.918 28.2851L210.226 19.6485C209.303 18.0949 208.238 16.6306 207.044 15.2745C204.77 12.7993 202.006 10.8254 198.927 9.47878C194.842 7.58111 190.377 6.64725 185.875 6.74925C181.906 6.75411 177.977 7.53258 174.306 9.04112C170.477 10.6158 167.047 13.0249 164.266 16.0928C161.158 19.5672 158.757 23.6132 157.195 28.0054C155.29 33.4645 154.38 39.221 154.507 45.0015C154.41 50.5358 155.188 56.0507 156.812 61.3424C158.149 65.6851 160.37 69.7046 163.334 73.1488C166.077 76.2632 169.496 78.7104 173.328 80.3041C177.349 81.9408 181.656 82.7578 185.996 82.7073C190.469 82.5954 194.909 81.8989 199.201 80.6356C202.984 79.9363 206.496 78.1945 209.343 75.6064L204.845 63.4737C202.922 65.179 200.737 66.5625 198.373 67.5706C194.993 69.0706 191.321 69.7987 187.625 69.7019C184.999 69.7884 182.39 69.2545 180.009 68.1436C177.628 67.0327 175.542 65.376 173.921 63.308C170.48 59.0453 168.763 52.944 168.768 45.0041C168.695 41.1512 169.156 37.3067 170.14 33.581C170.893 30.7442 172.178 28.0763 173.926 25.7187ZM270.92 45.0067C269.786 43.6423 268.382 42.527 266.796 41.7307C268.136 40.9697 269.325 39.969 270.304 38.7785C271.487 37.2239 272.482 35.535 273.269 33.7467L284.783 8.28234H269.978L259.559 31.776C258.933 33.6427 257.838 35.3167 256.377 36.6368C255.303 37.3433 254.038 37.7047 252.752 37.6727H245.412V8.30306H231.374V81.182H245.412V49.9297H253.64C254.551 49.87 255.462 50.0266 256.301 50.3867C257.139 50.7467 257.88 51.3001 258.464 52.0014C259.886 53.9853 261.029 56.1549 261.861 58.4497L270.853 81.1846H286.095L273.706 50.1472C273.053 48.2998 272.113 46.5667 270.92 45.0118V45.0067ZM101.223 8.29011L74.9039 81.182H89.271L108.244 25.4468L127.218 81.182H141.585L115.144 8.29011H101.223ZM325.256 8.29011L298.938 81.182H313.305L332.278 25.4468L351.251 81.182H365.618L339.183 8.29011H325.256ZM41.799 37.1418H14.1521V8.29011H0.11377V81.182H14.1521V50.3647H41.799V81.1638H55.8374V8.29011H41.799V37.1418ZM653.356 8.29011V53.752L625.173 8.29011H610.806V81.1638H624.733V32.9957L654.886 81.1872H667.171V8.29011H653.356ZM573.742 13.3193C569.118 9.71614 563.569 7.49643 557.736 6.91713C551.904 6.33782 546.026 7.42262 540.785 10.0459C536.873 12.1699 533.468 15.1164 530.803 18.6825C528.09 22.3441 526.065 26.4682 524.825 30.854C522.19 39.8831 522.19 49.4776 524.825 58.5067C526.059 62.8945 528.085 67.0195 530.803 70.6782C533.473 74.2527 536.876 77.2143 540.785 79.364C545.079 81.6642 549.896 82.8133 554.766 82.6995C559.705 82.812 564.592 81.6641 568.965 79.364C572.92 77.2347 576.366 74.271 579.063 70.6782C581.779 67.0102 583.822 62.8891 585.098 58.5067C586.439 54.0205 587.121 49.3629 587.123 44.6804C586.937 39.2891 585.977 33.9526 584.275 28.8341C582.369 22.7375 578.704 17.34 573.742 13.3193ZM571.223 55.5001C570.567 57.6978 569.646 59.8075 568.481 61.7826C567.103 64.0708 565.183 65.9847 562.891 67.3557C560.468 68.9033 557.649 69.7181 554.774 69.7019C552.088 69.7489 549.444 69.0303 547.151 67.6301C544.892 66.2172 542.981 64.3121 541.561 62.0571C540.001 59.5834 538.853 56.8719 538.164 54.0291C536.633 47.896 536.633 41.4802 538.164 35.3471C538.856 32.5053 540.003 29.7942 541.561 27.3191C542.981 25.0641 544.892 23.1591 547.151 21.7461C549.444 20.346 552.088 19.6274 554.774 19.6744C557.858 19.7257 560.864 20.6545 563.44 22.3521C566.594 24.5249 568.975 27.6448 570.239 31.2606C572.013 35.5182 572.908 40.091 572.869 44.7037C572.795 48.359 572.241 51.9888 571.223 55.5001ZM368.35 21.5182H389.079V81.1897H403.117V21.5182H423.846V8.29788H368.355V21.5182H368.35ZM485.03 37.1418H457.396V8.30306H443.358V81.182H457.396V50.3647H485.03V81.182H499.068V8.29011H485.03V37.1418ZM41.799 4.09741H55.8374V0.0808105H41.799V4.09741ZM457.396 0.267268H443.358V4.28128H457.396V0.267268ZM610.697 89.2022H624.735V85.1856H610.697V89.2022Z'
              fill='white'
            />
          </svg>
        </div>
      </div>
      <div className={styles["agenda-side"]}>
        <button
          className='QA-button'
          data-toggle='collapse'
          onClick={() => handleSlidoShow()}
        >
          <img src='/assets/agendaimg.svg'></img>
        </button>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        id='Reloader'
      >
        {loading ? null : (
          // <iframe
          //   src={agenda[0].sessionLink}
          //   style={{ paddingBottom: "7%", border: "none" }}
          //   width='850'
          //   height='500'
          //   frameborder='0'
          //   scrolling='no'
          //   allowfullscreen
          // ></iframe>
          <ReactPlayer
            id='video1'
            controls={true}
            muted={false}
            url={agenda[0].sessionLink}
            width='90vw'
            height='85vh'
          />
        )}
      </div>

      {/* <a
        src='/assets/glb/newmodel/ff1-01.png'
        className='btn-session'
        style={{
          padding: "0.5rem 0.5rem",
          border: "white 1px solid",
          color: "white",
          backgroundColor: "transparent",
        }}
        onClick={() => {
          history("/hall");
        }}
      >
        back to hall
      </a> */}

      {loading ? null : (
        <>
          <div
            className={`collapse slido-container ${
              slidoShow ? "hidden" : "show"
            }`}
            id='collapseOne'
            data-parent='#accordion'
          >
            <div className={styles["qa-header"]}>
              <span className={styles["agenda-title"]}>Agenda</span>
              {/* <button
                class='btn btn-secondary dropdown-toggle'
                type='button'
                id='dropdownMenuButton'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
                className={styles["ddl-btn"]}
              ></button> */}
              <span
                className={styles["date-in-agenda"]}
                type='button'
                id='dropdownMenuButton'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
              >
                {selectedDate}
                <img
                  className={styles["arrow-down"]}
                  src='/assets/arrow-down.svg'
                ></img>
              </span>
              <div
                class='dropdown-menu'
                aria-labelledby='dropdownMenuButton'
                style={{ width: "64%" }}
              >
                {dates.map((p) => (
                  <a
                    class='dropdown-item'
                    onClick={() => {
                      getdateAgenda(p.date);
                    }}
                    className={styles["drop-down-item"]}
                  >
                    {new Date(p.date).toLocaleString("default", {
                      day: "2-digit",
                      month: "short",
                    })}
                  </a>
                ))}
              </div>
            </div>
            <ul className={styles["agenda-list"]}>
              {DateAgenda.map((e) => {
                const dateObject = new Date(e.startDateTime);

                return (
                  <li className={styles["agenda-item"]}>
                    <span className={styles["time"]}>
                      {dateObject.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                    <div className={styles["speaker-div"]}>
                      <span className={styles["title"]}>{e.title}</span>
                      <span className={styles["speaker"]}>{e.host}</span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}

export default Session;
